exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-vue[data-v-087d7418]:before{left:0;width:60%;background:#15153b;background:linear-gradient(90deg,#15153b,rgba(21,21,59,0))}.banner-vue[data-v-087d7418]:after,.banner-vue[data-v-087d7418]:before{position:absolute;top:0;height:100%;z-index:3;content:\"\";filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=$primary,endColorstr=$primary,GradientType=1)}.banner-vue[data-v-087d7418]:after{right:0;width:20%;background:#15153b;background:linear-gradient(90deg,rgba(21,21,59,0),#15153b)}.image-banner-vue[data-v-087d7418]{opacity:.5;height:100%;display:block;margin:0 0 0 auto}", ""]);

// exports
